module.exports = __webpack_public_path__ + "img/cooperativeMedia3.b219ad24.png";